import React from "react";
import PropTypes from "prop-types";
import { Building2 } from "lucide-react";

import { UIEmptyState } from "../../../../../../components/ui";

const RegistrationEmptyState = ({ title, description }) => (
  <UIEmptyState
    title={title}
    description={description}
    icon={<Building2 aria-hidden />}
    classNames={{ root: "ui-empty-state--embedded" }}
  />
);

RegistrationEmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

RegistrationEmptyState.defaultProps = {
  description: null,
};

export default RegistrationEmptyState;
